import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import Home from './Home'
import ChooseCountry from './Country'
import { Universities } from './Universities'
import University from './University'
import ProjectMa from './ProjectMa'
import ProjectEs from './ProjectEs'
import ProjectFr from './ProjectFr'
import ProjectSg from './ProjectSg'
import ProjectAu from './ProjectAu'
import Upm from './Upm'
import Frnisi from './Frnisi'
import Sgsummer from './Sgsummer'
import Sgwinter from './Sgwinter'
import Convoy1 from './Convoy1'
import Convoy2 from './Convoy2'
import Convoy3 from './Convoy3'
import Convoy4 from './Convoy4'
import Convoy5 from './Convoy5'
import Convoy6 from './Convoy6'
import Convoy7 from './Convoy7'
import Convoy8 from './Convoy8'
import Convoy9 from './Convoy9'
import Convoy10 from './Convoy10'
import Convoy11 from './Convoy11'
import Convoy12 from './Convoy12'
import Convoy13 from './Convoy13'
import Jituan from './Jituan'

class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path="/home" component={Home} />
                        <Route exact path="/country" component={ChooseCountry} />
                        <Route exact path="/universities" component={Universities} />
                        <Route exact path="/university/:id" component={University} />
                        <Route exact path="/Project/Ma" component={ProjectMa} />
                        <Route exact path="/Project/Es" component={ProjectEs} />
                        <Route exact path="/Project/Fr" component={ProjectFr} />
                        <Route exact path="/Project/Sg" component={ProjectSg} />
                        <Route exact path="/Project/Au" component={ProjectAu} />
                        <Route exact path="/upm/" component={Upm} />
                        <Route exact path="/frnisi/" component={Frnisi} />
                        <Route exact path="/sgsummer/" component={Sgsummer} />
                        <Route exact path="/sgwinter/" component={Sgwinter} />
                        <Route exact path="/convoy/1" component={Convoy1} />
                        <Route exact path="/convoy/2" component={Convoy2} />
                        <Route exact path="/convoy/3" component={Convoy3} />
                        <Route exact path="/convoy/4" component={Convoy4} />
                        <Route exact path="/convoy/5" component={Convoy5} />
                        <Route exact path="/convoy/6" component={Convoy6} />
                        <Route exact path="/convoy/7" component={Convoy7} />
                        <Route exact path="/convoy/8" component={Convoy8} />
                        <Route exact path="/convoy/9" component={Convoy9} />
                        <Route exact path="/convoy/10" component={Convoy10} />
                        <Route exact path="/convoy/11" component={Convoy11} />
                        <Route exact path="/convoy/12" component={Convoy12} />
                        <Route exact path="/convoy/13" component={Convoy13} />
                        <Route exact path="/Jituan" component={Jituan} />
                        <Redirect from="/" to="/home" />
                    </Switch>
                </div>
            </Router>
        )
    }
}

export default App
